import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TmmsaisineSharedModule } from '../shared';

import {
    adminState,
    UserMgmtComponent,
    UserDialogComponent,
    UserDeleteDialogComponent,
    UserMgmtDetailComponent,
    UserMgmtDialogComponent,
    UserMgmtDeleteDialogComponent,
    JhiDocsComponent,
    UserResolvePagingParams,
    UserResolve,
    UserModalService, PurgeComponent, PurgeService
} from './';
import {ButtonModule, DataTableModule, DialogModule, InputTextModule, MultiSelectModule, AutoCompleteModule} from 'primeng/primeng';


@NgModule({
    imports: [
        TmmsaisineSharedModule,
        InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule, AutoCompleteModule,
        RouterModule.forRoot(adminState, { useHash: true })
    ],
    declarations: [
        UserMgmtComponent,
        UserDialogComponent,
        UserDeleteDialogComponent,
        UserMgmtDetailComponent,
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,
        JhiDocsComponent,
        PurgeComponent
    ],
    entryComponents: [
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,
    ],
    providers: [
        UserResolvePagingParams,
        UserResolve,
        UserModalService,
        PurgeService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TmmsaisineAdminModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.module.ts